import { Chip } from '@material-ui/core';
import { Palette } from '@material-ui/core/styles/createPalette';
import { ClassNameMap } from '@material-ui/styles';
import { LenderMap, pricingSpecInLenderContext } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { LenderIconAvatar } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { StyledTooltip } from '@/components/shared/components/StyledTooltip';
import { TooltipDetailRow } from '@/components/shared/components/TooltipDetailRow';

interface LenderEarningFeeProps {
  pricingSpecInLenderContext: pricingSpecInLenderContext;
  palette: Palette;
  classes: ClassNameMap<'label'>;
}

export const LenderEarningFee = ({ pricingSpecInLenderContext, palette, classes }: LenderEarningFeeProps) => {
  const lenderName = LenderMap.fromLenderId(pricingSpecInLenderContext.lenderId);
  if (!lenderName) return null;
  return (
    <StyledTooltip
      title={
        <>
          <TooltipDetailRow paramName={'lenderName'} value={lenderName} />
          <TooltipDetailRow paramName={'lenderId'} value={pricingSpecInLenderContext.lenderId} />
          <TooltipDetailRow
            paramName={'pricingNameInLenderContext'}
            value={pricingSpecInLenderContext.pricingNameInLenderContext}
          />
          <TooltipDetailRow paramName={'pricingVersion'} value={pricingSpecInLenderContext.pricingVersion} />
        </>
      }
    >
      <Chip
        className={classes.label}
        size={'small'}
        icon={<LenderIconAvatar lenderName={lenderName} size={'small'} />}
        label={
          <Font variant={'caption'} color={'textPrimary'}>
            {pricingSpecInLenderContext.pricingNameInLenderContext}
          </Font>
        }
        style={{ backgroundColor: palette.grey[50] }}
      />
    </StyledTooltip>
  );
};
